import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, contentChild, input, TemplateRef } from '@angular/core';

@Component({
  selector: 'prime-input-container',
  imports: [CommonModule],
  templateUrl: './input-container.component.html',
  styleUrls: ['./input-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputContainerComponent {
  readonly labelClasses = input<string>('');
  readonly labelPos = input<'left' | 'right' | null>(null);
  readonly labelGapClass = input<string>('tw:gap-2');
  readonly allClasses = computed(() => {
    const labelClasses = this.labelClasses();
    const labelGapClass = this.labelGapClass();
    const labelPos = this.labelPos();
    return [
      'tw:flex',
      labelPos !== null ? 'tw:items-center switch-container' : 'tw:flex-col',
      labelGapClass,
      labelClasses,
    ]
      .filter(Boolean)
      .join(' ');
  });

  readonly inputContent = contentChild<TemplateRef<null> | null>('inputContent');
  readonly labelContent = contentChild<TemplateRef<null> | null>('labelContent');
  readonly validationContent = contentChild<TemplateRef<null> | null>('validationContent');
}
